/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { resetInitialGraphState, setCenterGraph, setIsLoading } from "../store/slice/centerGraphSlice";
import { abort, getHomeRoomData } from "../multiplayer/SocketConnection";
import { setChecked } from "../store/slice/userSlice"
import {
    resetInitialHomeRoom,
    setKPISettings,
    setOpenedKPI,
} from "../store/slice/roomSlices/homeSlice"
import store from "../store/store"
import { HOME_ROOM } from "../rooms/RoomNameConstants";
import { setReason } from "../store/slice/privateSlice";
import { changeRoom, cleanHistory } from "../store/slice/roomSlice";
import { CENTER_GRAPH } from "../store/constants/homeFields";

export const homeRoomSetup = (data) => {
    getHomeRoomData(data)
}

export const handleToggleEngine = (label, engines) => {
    let engineList = [], selectedEngines = [...engines.selected];

    const dispatch = store.dispatch

    dispatch(resetInitialGraphState());
    dispatch(resetInitialHomeRoom());
    dispatch(setReason(false));

    // label === 'Name' it seems "select all"
    if (label === 'Name') {
        if (selectedEngines.length === engines.list.filter(e => e.available === "available").length) {
            selectedEngines = [];
        } else selectedEngines = engines.list.filter(e => e.available === "available").map((engine) => engine.name);
    } else {
        if (selectedEngines.includes(label)) {
            selectedEngines = selectedEngines.filter((engineName) => engineName !== label)
        } else {
            selectedEngines.push(label);
        }
    }

    // before getting DataFromWA engineList must be composed to every selectedEngine
    if (selectedEngines.length > 0) {
        dispatch(setIsLoading(true))

        selectedEngines.forEach((engineName) => {
            engineList.push(...engines.list.filter((engine) => engine.name === engineName))
        });

        homeRoomSetup({
            engineList,
            targetRoom: HOME_ROOM,
        })
    } else {
        abort("ToggleEngineOffBefonreTheEndOfLoading")
        setTimeout(() => {
            dispatch(resetInitialHomeRoom())
            dispatch(resetInitialGraphState())
        }, 1000)
        dispatch(setIsLoading(false))
        engineList = []
    }

    dispatch(setChecked(selectedEngines))
}

export const handleSetKPI = (callback) => {
    if (callback instanceof Function)
        store.dispatch(setOpenedKPI(callback()));
    else
        store.dispatch(setOpenedKPI({ opened: null }))
}

export const handleSetSettings = (callback) => {
    const data = callback();
    store.dispatch(setKPISettings(data));
}

export const handleGoToHomeRoom = () => {
    const history = store.getState().room.history
    const historicalHomeRoom = history[history.length - 2]

    if (!!historicalHomeRoom.cache) {
        let callback

        Object.keys(historicalHomeRoom.cache).forEach((key) => {
            callback = historicalHomeRoom.cache[key].callback
            if (callback instanceof Function) callback(historicalHomeRoom.cache[key])
            if (key === CENTER_GRAPH) store.dispatch(setCenterGraph(historicalHomeRoom.cache[key]))
        })
    }

    store.dispatch(cleanHistory())
    store.dispatch(changeRoom(HOME_ROOM))
}